import React, { useEffect } from "react";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';


export default function MyAccount() {

    const schema = yup.object({
        email: yup.string().email().required(),
        'family_name': yup.string().trim().required(),
        'given_name': yup.string().trim().required()
    }).required();

    const user = JSON.parse(sessionStorage.user)
    console.log('user--------', user)

    const { control, reset } = useForm({
        defaultValues: user,
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        reset(user)
    }, [reset, user])


    return (
        <PageShell>
            <PageHeader title="My Account" />

            <PageContent sx={{ p: { xs: 2, md: 3 } }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 720,
                    }}
                >
                    <Stack spacing={2}>
                        <Typography variant="body2" color="text.secondary">
                            Account details are read-only here and follow the identity profile tied to your login.
                        </Typography>
                        <Controller name="email" control={control} render={({ field }) => <TextField disabled margin='dense' fullWidth label='Email' {...field} />} />
                        <Controller name="family_name" control={control} render={({ field }) => <TextField disabled margin='dense' fullWidth label='Last Name' {...field} />} />
                        <Controller name="given_name" control={control} render={({ field }) => <TextField disabled margin='dense' fullWidth label='First Name' {...field} />} />
                    </Stack>
                </Box>
            </PageContent>
        </PageShell>
    )
}
